var map = {
	"./ar.json": 5310,
	"./en-US.json": 25381,
	"./es-ES.json": 39480,
	"./is-IS.json": 73776,
	"./lt-LT.json": 49184,
	"./pl-PL.json": 78136,
	"./ro-RO.json": 62062,
	"./sk-SK.json": 22472,
	"./sl-SI.json": 50157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89628;